import { render } from "./PMyFavorite.vue?vue&type=template&id=274b2745&scoped=true"
import script from "./PMyFavorite.vue?vue&type=script&lang=js"
export * from "./PMyFavorite.vue?vue&type=script&lang=js"

import "./PMyFavorite.vue?vue&type=style&index=0&id=274b2745&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274b2745"]])

export default __exports__